import { useCallback, useRef } from 'react';

import { useStoreContext } from 'features/store';

import { IRestaurant } from '@rbi-ctg/store';
import { CustomEventNames, EventTypes, logEvent } from 'state/amplitude';
import { ServiceMode, useServiceModeContext } from 'state/service-mode';

import { useStoreAvailabilityFns } from './use-store-availability-fns';

export const useAutoSelectStoreUtils = () => {
  const isManualRestaurantSelectionRef = useRef<boolean>();

  const { setStore, resetStore } = useStoreContext();
  const { setServiceMode } = useServiceModeContext();
  const { isStoreAvailableForPickup } = useStoreAvailabilityFns();

  const getFirstAvailableStore = useCallback(
    async (stores: IRestaurant[]) => {
      for (const store of stores) {
        const isAvailable = isStoreAvailableForPickup(store);
        if (isAvailable) {
          return store;
        }
      }

      return undefined;
    },
    [isStoreAvailableForPickup]
  );

  const handleConfirmRestaurant = ({
    confirmed,
    restaurantToConfirm,
    onSelect,
  }: {
    confirmed: boolean;
    restaurantToConfirm: IRestaurant | null;
    onSelect: (selectedRestaurant: IRestaurant | null) => void;
  }) => {
    if (restaurantToConfirm && confirmed) {
      setStore({ ...restaurantToConfirm });
      setServiceMode(ServiceMode.TAKEOUT);
      logEvent(CustomEventNames.STORE_AUTO_SELECTED, EventTypes.Other);
    } else {
      isManualRestaurantSelectionRef.current = true;
      resetStore();
    }
    onSelect(null);
  };

  return {
    getFirstAvailableStore,
    handleConfirmRestaurant,
    isManualRestaurantSelectionRef,
  };
};
